var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { Groupe } from 'messagerie/classes/Groupe.class';
import { Message } from 'messagerie/classes/Message.class';
import { Discussion } from 'messagerie/classes/Discussion.class';
export class MessagerieService {
    /**
     * Création d’un groupe
     * @param groupe Groupe à sauvegarder
     * @return Identifiant du groupe créé
     */
    static createGroup(groupe) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { groupe: groupe.toRaw() }, {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'CREATION_GROUPE',
                },
            });
            return content;
        });
    }
    /**
     * Recherche de messages
     * @param row paramètres de la recherche
     * @return liste des messages correspondants
     */
    static searchMessages(row) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: MessagerieService.rubModule, action: 'SEARCH_MESSAGES' }, row),
            });
            return content.map((message) => new Message(message));
        });
    }
    /**
     * Envoie et sauvegarde un message
     * @param message Données du message à envoyer
     * @return Les données du message avec l'identifiant créé et le recepteur à qui on envoi le message
     */
    static sendMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { message: message.toRaw() }, {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'SEND_MESSAGE',
                },
            });
            const newMessage = message;
            newMessage.idMessage = Number(content.idMessage);
            // TODO: Trouver un moyen de séparer la websocket et l'ajout du message en bdd afin d'améliorer le délais de réponse
            this.sendWebSocket(newMessage, content.membres);
            return { message: newMessage, recepteur: content.recepteur };
        });
    }
    /**
     * Envoi le nouveau message envoyé aux autres utilisateurs par websocket
     * @param message le message à envoyer aux membres
     * @param membres liste des membres devant recevoir le message
     * @return true si action réussie
     */
    static sendWebSocket(message, membres) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { message: message.toRaw(), membres }, {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'SEND_WEBSOCKET',
                },
            });
            return content;
        });
    }
    /**
     * Chargement des conversations de la messagerie
     * @return Données récupérées
     */
    static loadMessagerie() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'LOAD_MESSAGERIE',
                },
            });
            return {
                conversations: [
                    ...content.conversations.map((personne) => new Discussion(personne)),
                    ...content.groupes.map((groupe) => new Groupe(groupe)),
                ],
                contacts: content.contacts.map((contact) => new Discussion(contact)),
            };
        });
    }
    /**
     * Chargement de la conversation entre deux membres ou dans un groupe
     * @return Données récupérées
     */
    static loadConversation({ idConversation, type, offset, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'LOAD_CONVERSATION',
                    idConversation,
                    type,
                    offset,
                },
            });
            return type === 'groupe' ? new Groupe(content) : new Discussion(content);
        });
    }
    /**
     * Supprime virtuellement la conversation pour le membre connecté
     * @param idConversation destinataire des messages à supprimer
     * @param isGroup si ce sont des messages de groupe ou perso
     * @return succès de l'opération
     */
    static deleteConv(idConversation, isGroup = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idConversation, isGroup }, {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'DELETE_CONVERSATION',
                },
            });
            return content;
        });
    }
    /**
     * Définit une conversation comme lue
     * @param idConversation Identifiant de la conversation
     * @param group La conversation est un groupe ?
     * @return Nombre de messages lus grâce à l'action
     */
    static setConversationRead(idConversation, group = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idConversation, group }, {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'SET_CONVERSATION_READ',
                },
            });
            return content;
        });
    }
    /**
     * Charge le nombre de messages non lus
     * @return Nombre de messages non lus
     */
    static loadTotalNonLu() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'LOAD_TOTAL_UNREAD_MESSAGES',
                },
            });
            return content;
        });
    }
    /**
     * Fait quitter du groupe l'utilisateur connecté
     * @param idGroupe Identifiant du groupe
     * @return True si l'opération a réussie
     */
    static leaveGroup(idGroupe) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idGroupe }, {
                params: {
                    rub: MessagerieService.rubModule,
                    action: 'LEAVE_GROUP',
                },
            });
            return content;
        });
    }
}
MessagerieService.rubModule = 'messagerie';
//# sourceMappingURL=data:application/json;base64,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